import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { db } from '../../firebase'; // Firebase config
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

function Contactform() {
  const [formData, setFormData] = useState({
    name: '',
    shiftingfrom: '',
    mobile: '',
    message: '',
    shiftingto: '',
    date: ''
  });

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "contacts from"), {
        ...formData,
        createdAt: serverTimestamp()
      });
       alert("Message sent!");
      setFormData({ name: '', shiftingfrom: '', mobile: '', message: '' , shiftingto: '', date: ''});
    } catch (err) {
      alert("Error saving data: " + err.message);
    }
  };
const navigate = useNavigate();
  return (
    <form onSubmit={handleSubmit}>
      <input className='me-2 mt-1' name="name" onChange={handleChange} value={formData.name} placeholder="Name" required />
      <input className='me-2 mt-1' name="mobile" onChange={handleChange} value={formData.mobile} placeholder="Mobile No." required />
      <input className='me-2 mt-1' name="shiftingfrom" onChange={handleChange} value={formData.shiftingfrom} placeholder="Shifting From :" required />
            <input className='me-2 mt-1' name="shiftingto" onChange={handleChange} value={formData.shiftingto} placeholder="Shifting To :" required />
            <input className='me-2 mt-1' name="date" onChange={handleChange} value={formData.date} placeholder="Date :" required />

      <textarea className='me-2 mt-1' name="message" onChange={handleChange} value={formData.message} placeholder="Home Shifting, Car Shifting, Office Shifting, Home & Byke Shifting, Wirehouse Reloction" required />
      <center>
        <button className='messagedata mt-2' type="submit">Submit</button>
      </center>
    </form>
  );
}

export default Contactform;
